import { Container } from '@dma/ui';
import type { AboutContentDto } from '../application/dto/AboutContentDto';
import './Statistics.css';

export interface StatisticsProps {
  items: AboutContentDto['statistics'];
}

export function Statistics({ items }: StatisticsProps) {
  if (items.length === 0) {
    return null;
  }
  return (
    <section className="dma-statistics" aria-label="آمار شرکت">
      <Container>
        <div className="dma-statistics__grid">
          {items.map((item) => (
            <div key={item.label} className="dma-statistics__item">
              <span className="dma-statistics__value">{item.value}</span>
              <span className="dma-statistics__label">{item.label}</span>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
